import { URLS } from "../../shared/urls";
import config from "../../../config/config";

const MORTGAGE_EVENT_CATEGORY = "תפריט עליון משכנתאות";
const RENT_EVENT_CATEGORY = "תפריט עליון השכרה";
const CLICK_ACTION = "לחיצה";

const MAIN_PAGE_EVENT_CATEGORY = "עמוד ראשי";

const homeUrl = (path) => {
  const base = config.HOMEPAGE_URL.replace(/\/+$/, "");
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${base}${normalizedPath}`;
};

export const links = {
  mortgage: [
    {
      text: "לבדיקת זכאות משכנתא משלימה",
      link: URLS.MortgageQue,
      category: MORTGAGE_EVENT_CATEGORY,
      action: CLICK_ACTION,
      label: "לבדיקת זכאות משכנתא משלימה",
      external: true,
      bold: true,
    },
    {
      text: "מחשבון משכנתא משלימה",
      link: URLS.MortCalc,
      category: MORTGAGE_EVENT_CATEGORY,
      action: CLICK_ACTION,
      label: "עמוד מחשבון משכנתא משלימה",
    },
    {
      text: "ההלוואות שלנו",
      link: URLS.MortInfo,
      category: MORTGAGE_EVENT_CATEGORY,
      action: CLICK_ACTION,
      label: "ההלוואות שלנו",
      scrollTo: true,
      ref: "mortLoans",
    },
    {
      text: "מי אנחנו",
      link: URLS.MortInfo,
      category: MORTGAGE_EVENT_CATEGORY,
      action: CLICK_ACTION,
      label: "מי אנחנו",
      scrollTo: true,
      ref: "mortWhoWeAre",
    },
    {
      text: "מספרים עלינו",
      link: URLS.MortTestimonials,
      category: MORTGAGE_EVENT_CATEGORY,
      action: CLICK_ACTION,
      label: "מספרים עלינו",
    },
    {
      text: "שאלות ותשובות",
      link: URLS.MortQNA,
      category: MORTGAGE_EVENT_CATEGORY,
      action: CLICK_ACTION,
      label: "עמוד שאלות ותשובות",
    },
    {
      text: "צור קשר",
      link: URLS.MortInfo,
      category: MORTGAGE_EVENT_CATEGORY,
      action: CLICK_ACTION,
      label: "צור קשר",
      scrollTo: true,
      ref: "mortContact",
    },
  ],
  rent: [
    {
      text: "השכרה",
      category: MAIN_PAGE_EVENT_CATEGORY,
      action: `Header - השכרה`,
      link: homeUrl(URLS.RentIntro),
      overRideDefaultQueryParams: true,
      label: "השכרה",
      hasTooltip: true,
      links: [
        {
          label: "ראשי",
          to: homeUrl(URLS.RentIntro),
          category: MAIN_PAGE_EVENT_CATEGORY,
          action: `Header - המוצרים שלנו - ראשי`,
          external: true,
        },
        {
          label: "בדיקת דיירים",
          to: homeUrl(URLS.Doublecheck),
          category: MAIN_PAGE_EVENT_CATEGORY,
          action: `Header - המוצרים שלנו - בדיקת דיירים`,
          external: true,
        },
        {
          label: "ערבות מקיפה",
          to: homeUrl(URLS.Safecheck),
          category: MAIN_PAGE_EVENT_CATEGORY,
          action: `Header - המוצרים שלנו - ערבות מקיפה`,
          external: true,
        },
        {
          label: "ערבות Express",
          badge: "חדש",
          to: homeUrl(URLS.Express),
          category: MAIN_PAGE_EVENT_CATEGORY,
          action: `Header - המוצרים שלנו - Express`,
          external: true,
        },
        {
          label: "הלוואת Advance",
          badge: "חדש",
          to: homeUrl(URLS.AllInAdvance),
          category: MAIN_PAGE_EVENT_CATEGORY,
          action: `Header - המוצרים שלנו - Advance`,
          external: true,
        },
        {
          label: "חוזה שכירות",
          to: homeUrl(URLS.RentAgreement),
          category: MAIN_PAGE_EVENT_CATEGORY,
          action: `Header - המוצרים שלנו - חוזה שכירות`,
          external: true,
        },
        {
          label: "RentAI",
          to: URLS.Newsletter,
          category: MAIN_PAGE_EVENT_CATEGORY,
          action: `Header - המוצרים שלנו - rentAI`,
          external: false,
        },
        {
          label: "WeCheck PAY",
          to: homeUrl(URLS.WeCheckPay),
          category: MAIN_PAGE_EVENT_CATEGORY,
          action: `Header - המוצרים שלנו - WeCheck PAY`,
          external: true,
        },
        {
          label: "שירות ותמיכה",
          to: homeUrl(URLS.RentSupport),
          category: MAIN_PAGE_EVENT_CATEGORY,
          action: `Header - שירות ותמיכה השכרה`,
          external: true,
        },
      ],
    },
    {
      text: "משכנתאות",
      link: homeUrl(URLS.WcMortgage),
      overRideDefaultQueryParams: true,
      category: RENT_EVENT_CATEGORY,
      action: CLICK_ACTION,
      label: "עמוד משכנתאות",
      hasTooltip: true,
      links: [
        {
          label: "המשכנתא של WeCheck",
          to: homeUrl(URLS.WcMortgage),
          category: MAIN_PAGE_EVENT_CATEGORY,
          action: `Header - המשכנתא של WeCheck`,
          external: true,
        },
        {
          label: "שירות ותמיכה",
          to: homeUrl(URLS.MortgageSupport),
          category: MAIN_PAGE_EVENT_CATEGORY,
          action: `Header - משכנתאות - שירות ותמיכה`,
          external: true,
        },
      ],
    },
    {
      text: "אודותינו",
      link: homeUrl("/"),
      overRideDefaultQueryParams: true,
      category: RENT_EVENT_CATEGORY,
      action: CLICK_ACTION,
      label: "עמוד אודות",
      hasTooltip: true,
      links: [
        {
          label: "קצת עלינו",
          to: homeUrl(URLS.About),
          category: MAIN_PAGE_EVENT_CATEGORY,
          action: `Header - קצת עלינו`,
          external: true,
        },
        {
          label: "המייסדים",
          to: homeUrl(URLS.OurFounders),
          category: MAIN_PAGE_EVENT_CATEGORY,
          action: `Header - מייסדים`,
          external: true,
        },
        {
          label: "WeCheck בתקשורת",
          to: homeUrl(URLS.Media),
          category: MAIN_PAGE_EVENT_CATEGORY,
          action: `Header - אנחנו בתקשורת`,
          external: true,
        },
        {
          label: "לקוחות מספרים",
          to: homeUrl(URLS.Testimonials),
          category: MAIN_PAGE_EVENT_CATEGORY,
          action: `Header - לקוחות מספרים`,
          external: true,
        },
      ],
    },
    {
      text: "מידע מקצועי",
      link: "https://www.wecheck.co.il/blog/",
      overRideDefaultQueryParams: true,
      category: RENT_EVENT_CATEGORY,
      action: CLICK_ACTION,
      label: "מידע מקצועי",
      hasTooltip: true,
      links: [
        {
          label: "מידע מקצועי - השכרה",
          bold: true,
          to: "https://www.wecheck.co.il/blog/rentcat/",
          external: true,
          overRideDefaultQueryParams: true,
        },
        {
          label: "חוזה שכירות סטנדרטי",
          to: "https://www.wecheck.co.il/blog/%d7%97%d7%95%d7%96%d7%94-%d7%a9%d7%9b%d7%99%d7%a8%d7%95%d7%aa/",
          external: true,
        },
        {
          label: "שטר חוב",
          to: "https://www.wecheck.co.il/blog/%d7%a9%d7%98%d7%a8-%d7%97%d7%95%d7%91/",
          external: true,
        },
        {
          label: "ערבות בנקאית שכירות",
          to: "https://www.wecheck.co.il/blog/%d7%a2%d7%a8%d7%91%d7%95%d7%aa-%d7%91%d7%a0%d7%a7%d7%90%d7%99%d7%aa-%d7%9c%d7%a9%d7%9b%d7%99%d7%a8%d7%95%d7%aa/",
          external: true,
        },
        {
          label: "חישוב תשואה על הדירה",
          to: "https://www.wecheck.co.il/blog/%d7%97%d7%99%d7%a9%d7%95%d7%91-%d7%aa%d7%a9%d7%95%d7%90%d7%94-%d7%a2%d7%9c-%d7%93%d7%99%d7%a8%d7%94/",
          external: true,
        },
        {
          label: "מידע מקצועי - משכנתאות והלוואות",
          bold: true,
          to: "https://www.wecheck.co.il/blog/mortcat/",
          external: true,
          overRideDefaultQueryParams: true,
        },
        {
          label: "איחוד הלוואות",
          to: "https://www.wecheck.co.il/blog/%d7%90%d7%99%d7%97%d7%95%d7%93-%d7%94%d7%9c%d7%95%d7%95%d7%90%d7%95%d7%aa/",
          external: true,
        },
        {
          label: "משכנתא על נכס קיים",
          to: "https://www.wecheck.co.il/blog/%d7%9e%d7%a9%d7%9b%d7%a0%d7%aa%d7%90-%d7%a2%d7%9c-%d7%a0%d7%9b%d7%a1-%d7%a7%d7%99%d7%99%d7%9d/",
          external: true,
        },
        {
          label: "הון עצמי למשכנתא",
          to: "https://www.wecheck.co.il/blog/%d7%94%d7%95%d7%9f-%d7%a2%d7%a6%d7%9e%d7%99-%d7%9c%d7%9e%d7%a9%d7%9b%d7%a0%d7%aa%d7%90/",
          external: true,
        },
        {
          label: "משכנתא חוץ בנקאית",
          to: "https://www.wecheck.co.il/blog/%d7%9e%d7%a9%d7%9b%d7%a0%d7%aa%d7%90-%d7%97%d7%95%d7%a5-%d7%91%d7%a0%d7%a7%d7%90%d7%99%d7%aa/",
          external: true,
        },
        {
          label: "הלוואה כנגד הנכס",
          to: "https://www.wecheck.co.il/blog/%d7%94%d7%9c%d7%95%d7%95%d7%90%d7%94-%d7%9b%d7%a0%d7%92%d7%93-%d7%a0%d7%9b%d7%a1/",
          external: true,
        },
      ],
    },
    {
      text: "שאלות ותשובות",
      link: homeUrl(URLS.QNA),
      overRideDefaultQueryParams: true,
      category: RENT_EVENT_CATEGORY,
      action: CLICK_ACTION,
      label: "עמוד שאלות ותשובות",
      external: true,
    },
  ],
  mortgageOld: [
    {
      text: "לבדיקת זכאות משכנתא משלימה",
      link: URLS.MortgageQue,
      category: MORTGAGE_EVENT_CATEGORY,
      action: CLICK_ACTION,
      label: "לבדיקת זכאות משכנתא משלימה",
      external: true,
      bold: true,
    },
    {
      text: "מחשבון משכנתא משלימה",
      link: URLS.MortCalc,
      category: MORTGAGE_EVENT_CATEGORY,
      action: CLICK_ACTION,
      label: "עמוד מחשבון משכנתא משלימה",
    },
    {
      text: "מי אנחנו",
      link: URLS.MortInfo,
      category: MORTGAGE_EVENT_CATEGORY,
      action: CLICK_ACTION,
      label: "מי אנחנו",
      scrollTo: true,
      ref: "mortWhoWeAreOld",
    },
    {
      text: "השותפים שלנו",
      link: URLS.MortInfo,
      category: MORTGAGE_EVENT_CATEGORY,
      action: CLICK_ACTION,
      label: "השותפים שלנו",
      scrollTo: true,
      ref: "mortPartnersOld",
    },
    {
      text: "צור קשר",
      link: URLS.MortInfo,
      category: MORTGAGE_EVENT_CATEGORY,
      action: CLICK_ACTION,
      label: "צור קשר",
      scrollTo: true,
      ref: "mortContact",
    },
  ],
};

export const buttons = {
  mortgage: [
    {
      text: "כניסה ליועצים",
      color: "red",
      link: URLS.MortgageQue + "?agent=1",
      external: true,
      category: MORTGAGE_EVENT_CATEGORY,
      action: CLICK_ACTION,
      label: "כניסת יועץ",
    },
    {
      text: "איזור אישי",
      color: "blue",
      link: URLS.MortPersonalArea,
      personalArea: true,
    },
  ],
  rent: [
    {
      text: "אזור אישי",
      color: "dark-blue",
      link: URLS.IntroToPersonalAreas,
      category: RENT_EVENT_CATEGORY,
      action: CLICK_ACTION,
      label: "כניסת לאזור אישי",
      external: true,
    },
  ],
  rentAI: [
    {
      text: "אזור אישי",
      color: "dark-blue",
      overRideDefaultQueryParams: true,
      link: `${URLS.IntroToPersonalAreas}?utm_source=RentAI&utm_medium=personal-areas&utm_campaign=shai`,
      category: RENT_EVENT_CATEGORY,
      action: CLICK_ACTION,
      label: "כניסת לאזור אישי",
      external: true,
    },
  ],
};

export const logo = {
  category: "תפריט עליון לוגו",
  action: "לחיצה על לוגו WeCheck",
  label: "לוגו וויצ'ק - Header",
};
